/** Sisi terpanjang maksimum sebelum upload (px). */
export const IMAGE_UPLOAD_MAX_EDGE = 1280

/** Kualitas JPEG untuk upload operasional (selfie, bukti waste, dll.). */
export const IMAGE_UPLOAD_JPEG_QUALITY = 0.8

function loadImageFromBlob(blob: Blob): Promise<HTMLImageElement> {
  return new Promise((resolve, reject) => {
    const url = URL.createObjectURL(blob)
    const img = new Image()
    img.onload = () => {
      URL.revokeObjectURL(url)
      resolve(img)
    }
    img.onerror = () => {
      URL.revokeObjectURL(url)
      reject(new Error('Gagal membaca gambar'))
    }
    img.src = url
  })
}

function scaleDimensions(width: number, height: number, maxEdge: number): { width: number; height: number } {
  if (width <= maxEdge && height <= maxEdge) {
    return { width, height }
  }
  if (width >= height) {
    return {
      width: maxEdge,
      height: Math.max(1, Math.round((height / width) * maxEdge)),
    }
  }
  return {
    width: Math.max(1, Math.round((width / height) * maxEdge)),
    height: maxEdge,
  }
}

/**
 * Kompres gambar untuk upload: resize sisi terpanjang + encode JPEG.
 * Dipakai sebelum kirim ke backend/MinIO agar ukuran file konsisten.
 */
export async function compressImage(source: Blob | string): Promise<Blob> {
  const raw =
    typeof source === 'string'
      ? await (await fetch(source)).blob()
      : source

  if (!raw.type.startsWith('image/')) {
    throw new Error('File bukan gambar')
  }

  const img = await loadImageFromBlob(raw)
  const { width, height } = scaleDimensions(img.naturalWidth, img.naturalHeight, IMAGE_UPLOAD_MAX_EDGE)

  const canvas = document.createElement('canvas')
  canvas.width = width
  canvas.height = height

  const ctx = canvas.getContext('2d')
  if (!ctx) {
    throw new Error('Canvas tidak didukung di perangkat ini')
  }

  ctx.fillStyle = '#ffffff'
  ctx.fillRect(0, 0, width, height)
  ctx.drawImage(img, 0, 0, width, height)

  return new Promise((resolve, reject) => {
    canvas.toBlob(
      (blob) => {
        if (!blob) {
          reject(new Error('Gagal mengompres gambar'))
          return
        }
        resolve(blob)
      },
      'image/jpeg',
      IMAGE_UPLOAD_JPEG_QUALITY,
    )
  })
}
